import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/Assistant/AssistantButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EntityShareButton"] */ "/vercel/path0/app/Components/EntityShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfessorPortrait"] */ "/vercel/path0/app/professors/ProfessorPortrait.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
